import { render, staticRenderFns } from "./AliasSettings.vue?vue&type=template&id=72c394d2&scoped=true"
import script from "./AliasSettings.vue?vue&type=script&lang=js"
export * from "./AliasSettings.vue?vue&type=script&lang=js"
import style0 from "./AliasSettings.vue?vue&type=style&index=0&id=72c394d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c394d2",
  null
  
)

export default component.exports